export default __webpack_public_path__ + "static/media/icon-github-link.da8c79c3.svg";